// extracted by mini-css-extract-plugin
module.exports = {"slogan":"Slogan_slogan__2j8oF","freeAsInfreeBeer":"Slogan_freeAsInfreeBeer__39Xqy","sub":"Slogan_sub__1GSgf"};